import { createFeatureSelector } from '@ngrx/store';

import type { ReviewsFeatureState } from '../reducers';
import { reviewsFeatureSelectorKey } from '../reducers';

export const reviewsFeatureSelector =
  createFeatureSelector<ReviewsFeatureState>(reviewsFeatureSelectorKey);
